import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TransferDataService {

  private authUser = new BehaviorSubject({});
  private activeMeeting = new BehaviorSubject({});
  private activeUser = new BehaviorSubject({});
  private activeDocument = new BehaviorSubject({});
  private adminUser = new BehaviorSubject({});


  constructor(private router: Router) { }

  setAuthUser(user: any) {
    this.authUser.next(user);
    if (user.status === 'PENDING') {
      this.router.navigate(['/c-meeting/user', user.username], { fragment: 'passwords', queryParams: { unchanged: true } });
    }
  }
  getAuthUser() {
    return this.authUser.asObservable();
  }

  setActiveMeeting(meeting) {
    this.activeMeeting.next(meeting);
  }
  getActiveMeeting() {
    return this.activeMeeting.asObservable();
  }
  setActiveDocument(document) {
    this.activeDocument.next(document);
  }

  getActiveDocument() {
    return this.activeDocument.asObservable();
  }

  setActiveUser(meeting) {
    this.activeUser.next(meeting);
  }
  getActiveUser() {
    return this.activeUser.asObservable();
  }



}
